import React from "react";
import {
  Menu,
  Person,
  Tune,
  Category,
  ArrowRight,
  ExitToApp,
} from "@material-ui/icons";
import "../App.css";
import { NavLink } from "react-router-dom";

function Adnavbar() {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-10 mx-auto">
            <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top" id="mainNav">
              <div className="container">
                <NavLink className="navbar-brand" to="/admin" exact> One.all Admin </NavLink>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <Menu />
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                  <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <NavLink className="nav-link" aria-current="page" to="/" exact>
                        <Person /> Profile
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link" aria-current="page" to="/about" exact>
                        <Tune /> Settings
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown">
                      <a className="btn nav-link dropdown-toggle text-center" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-expanded="false" href="www.onedotall.in">
                        <Category /> Links
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li>
                          <a className="dropdown-item bg-white text-dark" href="https://www.youtube.com/channel/UCZLta3G00zz9Jc4zsiCRhtA" target="_blank" rel="noopener noreferrer">
                            <ArrowRight /> Youtube
                          </a>
                        </li>
                        <li>
                          <NavLink className="dropdown-item bg-white text-dark" to="/p404">
                            <ArrowRight /> Weblates
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <button className="btn btn-outline-warning">
                      Logout <ExitToApp />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default Adnavbar;
